import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import JsonLd from "@/components/base/JsonLd";

export default function About() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "首页", item: "https://hanmanwu.com/" },
      { "@type": "ListItem", position: 2, name: "关于我们", item: "https://hanmanwu.com/about" },
    ],
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "韩漫屋需要付费吗？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "韩漫屋是韩漫网站免费在线阅读平台，所有漫画资源均免费向用户开放，无需任何付费即可畅享海量韩国漫画内容。",
        },
      },
      {
        "@type": "Question",
        name: "漫画内容是否完整？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "我们提供无删减漫画，确保每部漫画内容完整。下拉式阅读方式让您流畅体验原汁原味的韩国漫画，不会遗漏任何精彩画面。",
        },
      },
      {
        "@type": "Question",
        name: "如何在手机上阅读？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "韩漫屋采用响应式设计，自动适配各种屏幕尺寸。您只需通过漫画免费韩漫网址访问，即可在手机、平板、电脑等设备上享受下拉式阅读体验。",
        },
      },
      {
        "@type": "Question",
        name: "漫画多久更新一次？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "我们每日更新漫画内容，热门连载作品会第一时间同步最新章节，确保您不会错过任何精彩剧情。",
        },
      },
      {
        "@type": "Question",
        name: "可以下载漫画离线阅读吗？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "韩漫屋为在线漫画阅读平台，您可以通过专属韩漫网址随时在线阅读。下拉式界面让在线阅读和下载离线阅读一样流畅。",
        },
      },
    ],
  };

  const aboutSchema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: "关于韩漫屋 - 韩漫网站免费在线阅读平台",
    description:
      "韩漫屋是专业的韩漫网站免费在线阅读平台，致力于为广大漫画爱好者提供最优质的韩国漫画阅读体验。",
    url: "https://hanmanwu.com/about",
    isPartOf: {
      "@type": "WebSite",
      name: "韩漫屋",
      url: "https://hanmanwu.com/",
    },
  };

  return (
    <>
      <JsonLd data={breadcrumbSchema} />
      <JsonLd data={aboutSchema} />
      <JsonLd data={faqSchema} />
      <Navbar />
      <main className="pt-16">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <nav className="flex items-center gap-2 py-4 text-xs text-foreground-500 font-label flex-wrap" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-800">关于我们</span>
          </nav>
        </div>

        <section className="w-full bg-background-100 py-12 md:py-16">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="text-3xl md:text-4xl font-bold font-heading text-foreground-950">
                关于韩漫屋
              </h1>
              <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                韩漫屋是专业的韩漫网站免费在线阅读平台，致力于为广大漫画爱好者提供最优质的韩国漫画阅读体验。
              </p>
            </div>
          </div>
        </section>

        <section className="w-full bg-background-50 py-12 md:py-16">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
              <div className="text-center p-6 rounded-lg bg-background-100">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto">
                  <i className="ri-book-read-line text-2xl"></i>
                </div>
                <h3 className="mt-4 text-lg font-bold font-heading text-foreground-950">海量资源</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  收录数千部热门韩国漫画，涵盖恋爱、奇幻、动作、剧情等全品类，持续更新。
                </p>
              </div>
              <div className="text-center p-6 rounded-lg bg-background-100">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto">
                  <i className="ri-shield-check-line text-2xl"></i>
                </div>
                <h3 className="mt-4 text-lg font-bold font-heading text-foreground-950">无删减内容</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  所有漫画均为无删减完整版本，确保读者能够体验原汁原味的韩国漫画内容。
                </p>
              </div>
              <div className="text-center p-6 rounded-lg bg-background-100">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mx-auto">
                  <i className="ri-smartphone-line text-2xl"></i>
                </div>
                <h3 className="mt-4 text-lg font-bold font-heading text-foreground-950">下拉式阅读</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  采用流畅的下拉式界面设计，适配各种设备，让阅读体验更加舒适自然。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full bg-background-100 py-12 md:py-16">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-8">
                品牌口碑
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div className="p-5 rounded-lg bg-background-50 border border-background-200/70">
                  <div className="flex items-center gap-1 text-accent-500 mb-3">
                    {[1, 2, 3, 4, 5].map((s) => (
                      <i key={s} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    "韩漫屋是我用过最好的韩漫网站，免费在线阅读体验非常好。漫画资源丰富，更新速度快，下拉式阅读也很方便。"
                  </p>
                  <p className="mt-3 text-xs text-foreground-500 font-label">—— 漫画爱好者 小李</p>
                </div>
                <div className="p-5 rounded-lg bg-background-50 border border-background-200/70">
                  <div className="flex items-center gap-1 text-accent-500 mb-3">
                    {[1, 2, 3, 4, 5].map((s) => (
                      <i key={s} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    "无删减漫画这点太赞了，很多平台都有删减，但韩漫屋的内容完整度一直很高，强烈推荐给喜欢韩国漫画的朋友。"
                  </p>
                  <p className="mt-3 text-xs text-foreground-500 font-label">—— 资深漫迷 小王</p>
                </div>
                <div className="p-5 rounded-lg bg-background-50 border border-background-200/70">
                  <div className="flex items-center gap-1 text-accent-500 mb-3">
                    {[1, 2, 3, 4, 5].map((s) => (
                      <i key={s} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    "从朋友那里知道了这个漫画免费韩漫网址，从此入坑。分类很全，找漫画特别方便，已经推荐给很多朋友了。"
                  </p>
                  <p className="mt-3 text-xs text-foreground-500 font-label">—— 新用户 小张</p>
                </div>
                <div className="p-5 rounded-lg bg-background-50 border border-background-200/70">
                  <div className="flex items-center gap-1 text-accent-500 mb-3">
                    {[1, 2, 3, 4, 5].map((s) => (
                      <i key={s} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    "韩漫网站里面最喜欢的平台，阅读界面干净整洁，下拉式设计特别适合手机上看漫画，每天必逛。"
                  </p>
                  <p className="mt-3 text-xs text-foreground-500 font-label">—— 忠实用户 小陈</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full bg-background-50 py-12 md:py-16">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-8">
                常见问题
              </h2>
              <div className="flex flex-col gap-3">
                {[
                  {
                    q: "韩漫屋需要付费吗？",
                    a: "韩漫屋是韩漫网站免费在线阅读平台，所有漫画资源均免费向用户开放，无需任何付费即可畅享海量韩国漫画内容。",
                  },
                  {
                    q: "漫画内容是否完整？",
                    a: "我们提供无删减漫画，确保每部漫画内容完整。下拉式阅读方式让您流畅体验原汁原味的韩国漫画，不会遗漏任何精彩画面。",
                  },
                  {
                    q: "如何在手机上阅读？",
                    a: "韩漫屋采用响应式设计，自动适配各种屏幕尺寸。您只需通过漫画免费韩漫网址访问，即可在手机、平板、电脑等设备上享受下拉式阅读体验。",
                  },
                  {
                    q: "漫画多久更新一次？",
                    a: "我们每日更新漫画内容，热门连载作品会第一时间同步最新章节，确保您不会错过任何精彩剧情。",
                  },
                  {
                    q: "可以下载漫画离线阅读吗？",
                    a: "韩漫屋为在线漫画阅读平台，您可以通过专属韩漫网址随时在线阅读。下拉式界面让在线阅读和下载离线阅读一样流畅。",
                  },
                ].map((faq, i) => (
                  <details
                    key={i}
                    className="group bg-background-100 rounded-lg border border-background-200/70 overflow-hidden"
                  >
                    <summary className="px-5 py-4 cursor-pointer flex items-center justify-between font-label text-sm md:text-base text-foreground-800 hover:text-primary-600 transition-colors">
                      {faq.q}
                      <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform"></i>
                    </summary>
                    <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                      {faq.a}
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="w-full bg-background-100 py-12 md:py-16">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-8">
                联系我们
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
                <div className="text-center p-6 rounded-lg bg-background-50 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto">
                    <i className="ri-mail-line text-lg"></i>
                  </div>
                  <h4 className="mt-3 text-sm font-semibold font-label text-foreground-900">电子邮箱</h4>
                  <p className="mt-1 text-sm text-foreground-600">contact@hanmanwu.com</p>
                </div>
                <div className="text-center p-6 rounded-lg bg-background-50 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto">
                    <i className="ri-qq-line text-lg"></i>
                  </div>
                  <h4 className="mt-3 text-sm font-semibold font-label text-foreground-900">QQ群</h4>
                  <p className="mt-1 text-sm text-foreground-600">123456789</p>
                </div>
                <div className="text-center p-6 rounded-lg bg-background-50 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mx-auto">
                    <i className="ri-wechat-line text-lg"></i>
                  </div>
                  <h4 className="mt-3 text-sm font-semibold font-label text-foreground-900">微信公众号</h4>
                  <p className="mt-1 text-sm text-foreground-600">韩漫屋</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}